import styled from 'styled-components'

export const FixedContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 4;
  pointer-events: none;
  transition: all 0.3s;
  min-height: 14.5rem;
  margin-bottom: ${(props) => (props.buyButtonVisible ? '3.75rem' : '0')};

  @media (max-width: 22.5rem) {
    min-height: 22.4375rem;
  }
`
export const FloatingComponentsArea = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 1.25rem;
  margin-bottom: 2.5rem;

  @media (min-width: 45rem) {
    padding: 0 5rem;
    margin-bottom: 2.5rem;
  }
`
export const PageTopButtonContainer = styled.div`
  pointer-events: all;
  display: flex;
  justify-content: flex-end;
  padding-top: 2.3125rem;
  align-items: center;
`
export const WhatsAppWrap = styled.div``

export const CookiesWarning = styled.div`
  width: 100%;
  display: ${(props) => (props.active ? 'flex' : 'none')};
  opacity: ${(props) => (props.active ? '1' : '0')};
  pointer-events: ${(props) => (props.active ? 'all' : 'none')};

  * {
    @media (max-width: 32.5rem) {
      font-size: 0.875rem !important;
    }
  }

  p {
    margin-bottom: 0rem;
  }
`
